export default __webpack_public_path__ + "static/media/cp_geo_ch.49d277c9.svg";